import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatTableDataSource, MatPaginator, MatSnackBar } from '@angular/material';
import { AddCampaignComponent } from '../add-campaign/add-campaign.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { environment } from "../../../../environments/environment";

@Component({
    selector: 'app-campaign-list',
    templateUrl: './campaign-list.component.html',
    styleUrls: ['./campaign-list.component.scss']
})

export class CampaignListComponent implements OnInit {
    displayedColumns = ['name', 'location', 'isDefault', 'paid', 'source', 'creatername', 'startDate', 'endDate', 'url', 'delete'];
    campaignIdToDelete;
    campaignList: Campaign[] = [];
    dataSource = new MatTableDataSource<Campaign>(this.campaignList);

    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(private dialog: MatDialog,
        private spinnerService: Ng4LoadingSpinnerService,
        private httpService: HttpService,
        private snackbar: MatSnackBar) { }

    ngOnInit() {
        this.dataSource.paginator = this.paginator;
        this.getCampaignList();
    }

    getCampaignList() {
        this.spinnerService.show();
        var contentBody = { url: "/campaigns" }
        this.httpService.httpGet(contentBody).subscribe(response => {
            this.campaignList = response;
            for (var i = 0; i < response.length; i++) {
                if (response[i].campaignPurpose == "MCQ_TEST") {
                    response[i].url = environment.websiteUrl + "/?cid=" + response[i].cid + "&type=mcq";
                }
                else if (response[i].campaignPurpose == "REGISTER_ONLY") {
                    response[i].url = environment.websiteUrl + "/?cid=" + response[i].cid + "&type=reg";
                }
                else {
                    response[i].url = environment.websiteUrl + "/?cid=" + response[i].cid + "&type=reg&refType=ref";
                }
            }
            this.dataSource = new MatTableDataSource(this.campaignList);
            this.dataSource.paginator = this.paginator;
            console.log("campaignList", this.campaignList);
            this.spinnerService.hide();

        }, error => {
            console.log("error ", error);
            this.spinnerService.hide();
            this.openSnackBar(error.error.message)
        })
    }

    deleteCampaign(campaignId) {
        this.campaignIdToDelete = campaignId;
        this.confirmDialog();
    }
    deleteCampaignFromList() {
        console.log("delete>>>>>>>>>>>>>>>");

        var data = {
            "campaignId": this.campaignIdToDelete
        }
        this.spinnerService.show();
        var contentBody = { url: "/campaigns/" + this.campaignIdToDelete, body: data }
        this.httpService.httpDelete(contentBody).subscribe(response => {
            console.log("delete", response);
            this.getCampaignList();

        },
            error => {
                console.log("Error", error);
                this.spinnerService.hide();
                this.openSnackBar(error.error.message)
            })
    }
    confirmDialog() {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            data: { "discription": "Are you sure want to delete this campaign..?" },
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
            if (result == true) {
                this.deleteCampaignFromList();
            }

        });
    }
    openSnackBar(message: string) {
        if (message) {
            this.snackbar.open(message, null, {
                duration: 2000,
            });
        }
        else {
            this.snackbar.open('Network Error', null, {
                duration: 2000,
            });
        }
    }

    openAddCampaignDialog() {
        const dialogRef = this.dialog.open(AddCampaignComponent, {
            width: '600px',
            disableClose: true,
            data: this.campaignList
        })

        dialogRef.afterClosed().subscribe(result => {
            console.log("result", result);
            if (result == true) {
                this.getCampaignList();
            }
        })
    }

    applyFilter(filterValue: any) {
        console.log(filterValue);
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
}
export interface Campaign {
    cId: string;
    name: string;
    location: string;
    company: string;
}

